__turbopack_context__.v({
  "container": "generating-spinner-module__gfv58G__container",
  "spin": "generating-spinner-module__gfv58G__spin",
  "spinner": "generating-spinner-module__gfv58G__spinner",
  "subtitle": "generating-spinner-module__gfv58G__subtitle",
  "title": "generating-spinner-module__gfv58G__title",
});
